(function () {
  'use strict';
  var ATTR_TYPE = 'Vásárlás típusa';
  var ATTR_CO   = 'Cégnév';
  var ATTR_VAT  = 'Céges adószám';
  var TOGGLE_ID = 'cart-business-invoice';
  var VAT_ID    = 'cart-vat-number';
  var state = { company: false, co: '', vat: '', saving: null, loaded: false };

  /* ---------- adószám segédek ---------- */
  function digitsOnly(s) { return String(s || '').replace(/\D/g, ''); }
  function stripHu(s) {
    var t = String(s || '').trim().replace(/\s+/g, '');
    var hadHu = /^hu/i.test(t);
    if (hadHu) t = t.slice(2);
    return { value: t, hadHu: hadHu };
  }
  function maskVat(s) {
    var d = digitsOnly(s).slice(0, 11);
    if (d.length <= 8) return d;
    if (d.length === 9) return d.slice(0, 8) + '-' + d.slice(8);
    return d.slice(0, 8) + '-' + d.slice(8, 9) + '-' + d.slice(9);
  }
  function vatChecksumOk(d8) {
    var w = [9, 7, 3, 1, 9, 7, 3], sum = 0;
    for (var i = 0; i < 7; i++) sum += parseInt(d8.charAt(i), 10) * w[i];
    var chk = (10 - (sum % 10)) % 10;
    return chk === parseInt(d8.charAt(7), 10);
  }
  function validVat(s) {
    if (!/^\d{8}-\d-\d{2}$/.test(s)) return false;
    var afa = s.charAt(9);
    if ('12345'.indexOf(afa) === -1) return false;
    return vatChecksumOk(s.slice(0, 8));
  }

  /* ---------- DOM segédek ---------- */
  function onCartPage() { return location.pathname.indexOf('/cart') === 0 && !/\/cart\/(add|change|update|clear)/.test(location.pathname); }
  function toggleEl() { return document.getElementById(TOGGLE_ID); }
  function vatEl() { return document.getElementById(VAT_ID); }
  function coEl() { return document.getElementById('oko-co-name'); }
  function detailsEl() { return document.getElementById('cart-company-fields-details'); }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in (attrs || {})) e.setAttribute(k, attrs[k]);
    if (html) e.innerHTML = html;
    return e;
  }

  /* Cégesnek számít-e a vásárló? Kosároldalon a jelölőnégyzet dönt, máshol a mentett kosár-attribútum. */
  function isCompany() {
    var t = toggleEl();
    if (t) return !!t.checked;
    return !!state.company;
  }

  /* ---------- cart attribútum mentés ---------- */
  function saveAttrs() {
    var company = isCompany();
    var attrs = {};
    attrs[ATTR_TYPE] = company ? 'Céges' : 'Magánszemély';
    attrs[ATTR_CO]   = company ? (state.co || '') : '';
    attrs[ATTR_VAT]  = company ? (state.vat || '') : '';
    state.company = company;
    state.saving = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (r) { state.saving = null; return r; });
    return state.saving;
  }

  /* ---------- érvényesség: CSAK céges esetben lehet probléma ---------- */
  function problem() {
    if (!isCompany()) return '';
    if (!state.co || state.co.trim().length < 3)
      return 'Céges számlához add meg a számlázási cégnevet!';
    if (!state.vat)
      return 'Céges számlához kötelező a magyar adószám megadása (pl. 12345678-2-42)!';
    if (!validVat(state.vat))
      return 'Az adószám formátuma vagy ellenőrző számjegye hibás. Helyes formátum: 12345678-2-42.';
    return '';
  }

  /* ---------- hibaüzenet a Fizetés gomb fölött ---------- */
  function errBox() {
    var box = document.getElementById('oko-vat-error');
    if (box) return box;
    var cartForm = document.getElementById('cart-form') || document.querySelector('form[action="/cart"], form[action^="/cart?"]');
    var btn = cartForm && cartForm.querySelector('[name="checkout"]');
    if (!btn || btn.offsetParent === null) {
      /* Impact-témánál a gomb nincs formban: a LÁTHATÓ pénztár gombot keressük (ne a rejtett drawer-belit) */
      var all = document.querySelectorAll('[name="checkout"], button[formaction*="/checkout"]');
      for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) { btn = all[i]; break; } }
      if (!btn && all.length) btn = all[0];
    }
    if (!btn) return null;
    box = el('div', { id: 'oko-vat-error', role: 'alert', style: 'display:none;margin:0 0 12px;padding:10px 12px;border-radius:6px;background:#fde8e8;color:#b30000;font-size:0.9em;line-height:1.35;' });
    btn.parentNode.insertBefore(box, btn);
    return box;
  }
  function showErr(msg, focusField) {
    var box = errBox();
    if (!box) { if (msg) alert(msg); return; }
    box.textContent = msg || '';
    box.style.display = msg ? 'block' : 'none';
    if (msg) {
      var d = detailsEl();
      if (d && d.hidden) d.hidden = false;
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { box.scrollIntoView(); }
      if (focusField && focusField.focus) setTimeout(function () { try { focusField.focus({ preventScroll: true }); } catch (e) {} }, 350);
    }
  }

  /* ---------- UI a kosároldalon: cégnév mező + adószám maszk a meglévő panelbe ---------- */
  function buildUi() {
    var toggle = toggleEl(), vatInput = vatEl(), details = detailsEl();
    if (!toggle || !vatInput || !details) return;
    if (document.getElementById('oko-vat-block')) return;

    /* Cégnév mező az adószám mező elé */
    var vatField = vatInput.closest('.cart-company-fields__field') || vatInput.parentNode;
    var wrap = el('div', { id: 'oko-vat-block', class: 'cart-company-fields__field v-stack gap-1', style: 'margin-bottom:10px;' });
    wrap.appendChild(el('label', { for: 'oko-co-name', class: 'cart-company-fields__label text-sm bold' }, 'Számlázási cégnév <span aria-hidden="true">*</span>'));
    var coInput = el('input', { id: 'oko-co-name', type: 'text', class: 'cart-company-fields__input', placeholder: 'Pl. Minta Kereskedelmi Kft.', autocomplete: 'organization', maxlength: '120' });
    wrap.appendChild(coInput);
    vatField.parentNode.insertBefore(wrap, vatField);

    /* Adószám mező: numerikus billentyűzet, maszk, HU-előtag levágás */
    vatInput.setAttribute('inputmode', 'numeric');
    vatInput.setAttribute('maxlength', '13');
    vatInput.setAttribute('autocomplete', 'off');
    if (!vatInput.getAttribute('placeholder')) vatInput.setAttribute('placeholder', 'Pl. 12345678-2-42');
    if (!document.getElementById('oko-vat-hint')) {
      var hint = el('div', { id: 'oko-vat-hint', style: 'font-size:0.8em;color:#666;margin-top:4px;' }, 'A kötőjeleket automatikusan pótoljuk. Magyar formátumú adószám kell: 12345678-2-42 (a HU előtagot levágjuk).');
      vatField.appendChild(hint);
    }

    /* Kezdőértékek a kosár-attribútumokból */
    coInput.value = state.co || '';
    if (state.vat && !vatInput.value) vatInput.value = state.vat;
    state.vat = maskVat(stripHu(vatInput.value).value);
    if (state.company && !toggle.checked) {
      toggle.checked = true;
      toggle.setAttribute('aria-expanded', 'true');
      details.hidden = false;
      vatInput.required = true;
    }

    /* Események */
    coInput.addEventListener('input', function () { state.co = this.value; if (state.co.trim().length >= 3) showErr(''); });
    coInput.addEventListener('change', function () { state.co = this.value; saveAttrs(); });
    vatInput.addEventListener('input', function () {
      var sh = stripHu(this.value);
      this.value = maskVat(sh.value);
      state.vat = this.value;
      if (sh.hadHu) showErr('A HU előtagot levágtuk – magyar formátumú adószámot kérünk: 12345678-2-42.');
      else if (validVat(this.value)) showErr('');
    });
    vatInput.addEventListener('change', function () { state.vat = this.value; saveAttrs(); });
    toggle.addEventListener('change', function () {
      if (!this.checked) { state.co = ''; state.vat = ''; if (coEl()) coEl().value = ''; }
      showErr('');
      saveAttrs();
    });
    errBox();
  }

  /* ---------- pénztár-őr (kosároldal + drawer + vásárlás-most) ---------- */
  function isCheckoutTrigger(t) {
    if (!t || !t.closest) return null;
    return t.closest('[name="checkout"], a[href*="/checkout"], button[formaction*="/checkout"], [data-checkout], .shopify-payment-button button');
  }
  function guard(ev) {
    var msg = problem();
    if (msg) {
      ev.preventDefault();
      ev.stopPropagation();
      if (toggleEl()) {
        var f = (!state.co || state.co.trim().length < 3) ? coEl() : vatEl();
        showErr(msg, f);
      } else {
        try { sessionStorage.setItem('okoVatMsg', msg); } catch (e) {}
        window.location.href = '/cart';
      }
      return;
    }
    /* Minden rendben (magánszemély, vagy céges teljes adatokkal): attribútum mentése, majd irány a pénztár */
    ev.preventDefault();
    ev.stopPropagation();
    var p = state.saving || saveAttrs();
    var done = false;
    function go() { if (!done) { done = true; window.location.href = '/checkout'; } }
    p.then(go, go);
    setTimeout(go, 2500); /* biztonsági háló: ha a mentés elakadna, akkor is továbbengedjük */
  }
  document.addEventListener('click', function (ev) {
    if (isCheckoutTrigger(ev.target)) guard(ev);
  }, true);
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.action) return;
    var toCheckout = String(f.action).indexOf('/checkout') !== -1;
    var cartCheckout = String(f.action).indexOf('/cart') !== -1 && ev.submitter && ev.submitter.name === 'checkout';
    if (toCheckout || cartCheckout) guard(ev);
  }, true);

  /* ---------- init ---------- */
  function init() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart) return;
      var a = cart.attributes || {};
      state.co  = a[ATTR_CO] || '';
      state.vat = a[ATTR_VAT] || '';
      state.company = (a[ATTR_TYPE] === 'Céges') || !!state.vat;
      state.loaded = true;
      if (onCartPage() && cart.item_count > 0) {
        buildUi();
        var m = null;
        try { m = sessionStorage.getItem('okoVatMsg'); sessionStorage.removeItem('okoVatMsg'); } catch (e) {}
        if (m) showErr(m);
        new MutationObserver(function () {
          if (!document.getElementById('oko-vat-block')) buildUi();
          else if (!document.getElementById('oko-vat-error')) errBox();
        }).observe(document.body, { childList: true, subtree: true });
      }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
